//import { mainnet, goerli, sepolia } from 'wagmi/chains'
//import { Chain } from 'wagmi'

// https://docs.megaeth.com/
export const megaethTestnet = {
  id: 6343,
  name: 'MegaETH Testnet',
  network: 'megaethtestnet',
  nativeCurrency: {
    decimals: 18,
    name: 'MEGA Testnet Ether',
    symbol: 'ETH',
  },
  rpcUrls: {
    public: { http: ['https://carrot.megaeth.com/rpc'] },
    default: { http: ['https://carrot.megaeth.com/rpc'] },
  },
  blockExplorers: {
    etherscan: { name: 'Block Explorer', url: 'https://megaeth-testnet-v2.blockscout.com' },
    default: { name: 'Block Explorer', url: 'https://megaeth-testnet-v2.blockscout.com' },
  }
} 

// https://docs.megaeth.com/
export const megaethMainnet = {
  id: 4326,
  name: 'MegaETH Mainnet',
  network: 'megaeth',
  nativeCurrency: {
    decimals: 18,
    name: 'MEGA Ether',
    symbol: 'ETH',
  },
  rpcUrls: {
    public: { http: ['https://mainnet.megaeth.com/rpc'] },
    default: { http: ['https://mainnet.megaeth.com/rpc'] },
  },
  blockExplorers: {
    etherscan: { name: 'Block Explorer', url: 'https://megaeth.blockscout.com/' },
    default: { name: 'Block Explorer', url: 'https://megaeth.blockscout.com/' },
  }
} 



// https://hyperliquid.gitbook.io/hyperliquid-docs/onboarding/how-to-use-the-hyperevm
export const hyperliquid = {
  id: 999,
  name: 'Hyperliquid EVM',
  network: 'hyperliquid',
  nativeCurrency: {
    decimals: 18,
    name: 'Hype',
    symbol: 'HYPE',
  },
  rpcUrls: {
    default: { http: ['https://rpc.hyperliquid.xyz/evm'] },
    public: { http: ['https://rpc.hyperliquid.xyz/evm'] },
  },
  blockExplorers: {
    etherscan: { name: 'Block Explorer', url: 'https://hyperliquid.cloud.blockscout.com' },
    default: { name: 'Block Explorer', url: 'https://hyperliquid.cloud.blockscout.com' },
  }
} 

export function abbreviateAddress(address: string, charsLength: number = 4): string {
  if (typeof address !== 'string') return '';
  if (address.length < charsLength * 2 + 2) return address;

  const prefix = address.substr(0, charsLength + 2); // '0x' + charsLength characters
  const suffix = address.substr(-charsLength);

  return `${prefix}...${suffix}`;
}

export const baseTestChain = {
  id: 84532,
  name: 'Base Sepolia',
  network: 'basesepolia',
  nativeCurrency: {
    decimals: 18,
    name: 'Ethereum',
    symbol: 'ETH',
  },
  rpcUrls: {
    public: { http: ['https://sepolia.base.org'] },
    default: { http: ['https://sepolia.base.org'] },
  },
  blockExplorers: {
    etherscan: { name: 'Block Explorer', url: 'https://sepolia.basescan.org' },
    default: { name: 'Block Explorer', url: 'https://sepolia.basescan.org' },
  }
} 


const getEtherScan = () => {
  switch (chain.network) {
    case "blast":  return "https://blastscan.io";
    case "blastsepolia":  return "https://testnet.blastscan.io";
    case "basesepolia":  return "https://sepolia.basescan.org";
    case "sepolia":  return "https://sepolia.etherscan.io";
    case "goerli":  return "https://goerli.etherscan.io";
    case "hyperliquid":  return "https://hyperliquid.cloud.blockscout.com";
    case "megaethtestnet":  return "https://megaeth-testnet-v2.blockscout.com";
    case "megaeth":  return "https://megaeth.blockscout.com";
  }
}

const useTestnet = String(process.env.REACT_APP_USE_TESTNET).toLowerCase() === "true";


//export const chain = megaethMainnet; // <-- MAINNET SET LIVE
export const chain = useTestnet ? megaethTestnet : megaethMainnet; // <-- MAINNET SET LIVE

console.log(`Use Testnet: ${process.env.REACT_APP_USE_TESTNET}`)
console.log(`Chain: ${chain.name}`)
console.log(`Chain ID: ${chain.id}`)
console.log(`Chain Network: ${chain.network}`)
console.log(`Chain Native Currency: ${chain.nativeCurrency.name}`)
console.log(`Chain Native Currency Symbol: ${chain.nativeCurrency.symbol}`)
console.log(`Chain Native Currency Decimals: ${chain.nativeCurrency.decimals}`)
console.log(`Chain RPC URLs: ${chain.rpcUrls.public.http[0]}`)
console.log(`Chain Block Explorers: ${chain.blockExplorers.etherscan.url}`)

export const contractAddress = useTestnet
  ? process.env.REACT_APP_CONTRACT_FRONTEND_TESTNET
  : process.env.REACT_APP_CONTRACT_FRONTEND_MAINNET;

export const getEtherscanAddressLink = (hash) => {
  return `${getEtherScan()}/address/${hash}`;
}

export const getEtherscanTxnLink = (hash) => {
  return `${getEtherScan()}/tx/${hash}`;
}

export const getEtherscanContractLink = (hash) => {
  return `${getEtherScan()}/address/${hash}`;
}

console.log(`Chain: ${chain.name} (${chain.id})`)
console.log(`Contract: ${getEtherscanContractLink(contractAddress)}`)


export const links = {
  megaeth: "https://megaeth.com",
  txnContractCreation: `${getEtherScan()}/tx/0x367aa7447b4405225830ba3b34381926db82710b48957d4d3e73b75d0106806a`,
  twitter: "https://x.com/dailofrog",
  twitterGoop: "https://x.com/goopgoop_art",
  discord: "https://discord.gg/KBAbk2a4PM",
  contractFrontEnd: getEtherscanContractLink(contractAddress),
  blurStore: "https://blur.io/",
  opensea: "https://opensea.io/collection/shrines",
  elementStore: "https://element.market/collections/skulls",
  blur: "https://blur.io/blast/collection/skulls",
  net: "https://www.netprotocol.app/app/bazaar/hyperliquid/0xDD59aC38cb15F688c18909bA1Ca708A76cC351F5",
  driptrade: "https://app.drip.trade/collections/skulls",
};
